// Module
var code = "<template>\r\n\t<require from=\"./core-tooltip.scss\"></require>\r\n\r\n\t<div class=\"arec-tooltip\">\r\n\t\t<slot></slot>\r\n\t</div>\r\n</template>\r\n";
// Exports
module.exports = code;